import { getEnvVar } from "./env";

export const Tenant = {
    getId: () => getEnvVar("REACT_APP_TENANT_ID") || "default",
    getName: () => getEnvVar("REACT_APP_TENANT_NAME") || "***tenant name***",
    getLogo: () => require(`assets/images/tenants/${Tenant.getId()}.png`),
    getTheme: () => getEnvVar("REACT_APP_THEME"),
    getWebsite: () => getEnvVar("REACT_APP_TENANT_WEBSITE"),
    getFeatures: () => ({
        forms: {
            enabled: getEnvVar("REACT_APP_FEATURES_FORMS_ENABLED") === "true",
        },
        visitors: {
            enabled: getEnvVar("REACT_APP_FEATURES_VISITORS_ENABLED") === "true",
        },
    }),
};
